import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


export const RolesPageSkeleton = () => (
    <Group direction="v">
        <Item className="pd-m" grow={1}>
            <Group justify="space-between">
                <Group gap="m">
                    <SkeletonItem width={210} height={40}/>
                    <SkeletonItem width={158} height={24}/>
                </Group>
                <SkeletonItem width={90} height={32}/>
            </Group>
        </Item>
        <Item className="pd-l">
            <Table>
                <Head>
                    <Cell width={400}><SkeletonItem width={100} height={18}/></Cell>
                    <Cell><SkeletonItem width={150} height={18}/></Cell>
                    <Cell width={120} className="text-align_right"><SkeletonItem width={100} height={18}/></Cell>
                </Head>
                <Body>
                    {Array.from({length: 10}, (profile, i) => (
                        <Row key={i}>
                            <Cell><SkeletonItem width={200} height={18}/></Cell>
                            <Cell><SkeletonItem width={300} height={18}/></Cell>
                            <Cell className="text-align_right"><SkeletonItem width={50} height={18}/></Cell>
                        </Row>
                    ))}
                </Body>
            </Table>
        </Item>
    </Group>
);
